import React, { FC } from 'react'
import { StyledIcon, StyledIconProps } from '.'

export const CsXIcon: FC<StyledIconProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M640 512l327.111-327.111-128-128L512 384 184.889 56.889l-128 128L384 512 56.889 839.111l128 128L512 640l327.111 327.111 128-128L640 512z" />
    </g>
  </StyledIcon>
)

CsXIcon.displayName = 'CsXIcon'
